import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Select } from '@knockrentals/knock-shared-web';
import {
  TRIGGER_ACTION_DESC,
  TRIGGER_OFFSET_TIMING,
} from '../../Campaign/constants';
import { DAYS_TO_DELAY_LABEL_TEXT } from './constants';

const useStyles = makeStyles({
  triggerTimingSelect: {
    '&.MuiInputBase-root': {
      paddingLeft: '12px',
      width: '280px',
    },
  },
});

const { AFTER, BEFORE } = TRIGGER_OFFSET_TIMING;

export const TIMING_OFFSET_DIRECTION_OPTIONS = [
  {
    label: `${DAYS_TO_DELAY_LABEL_TEXT[AFTER]} ${TRIGGER_ACTION_DESC.DEFAULT}`,
    value: AFTER,
  },
  {
    label: `${DAYS_TO_DELAY_LABEL_TEXT[BEFORE]} ${TRIGGER_ACTION_DESC.DEFAULT}`,
    value: BEFORE,
  },
];

const OffsetSelect = ({
  campaignTriggerOffsetModifier,
  updateCampaignTriggerOffsetModifier,
}) => {
  const classes = useStyles();

  const handleOffsetModifierOnChange = (value) => {
    const offsetModifierValue = value === BEFORE ? -1 : 1;
    updateCampaignTriggerOffsetModifier(offsetModifierValue);
  };

  const campaignTriggerOffsetModifierValue =
    campaignTriggerOffsetModifier === -1 ? BEFORE : AFTER;

  return (
    <Select
      aria-label="select trigger timing offset"
      className={classes.triggerTimingSelect}
      displayEmpty
      noForm
      onSelectChange={handleOffsetModifierOnChange}
      options={TIMING_OFFSET_DIRECTION_OPTIONS}
      value={campaignTriggerOffsetModifierValue}
    />
  );
};

OffsetSelect.propTypes = {
  campaignTriggerOffsetModifier: PropTypes.number,
  updateCampaignTriggerOffsetModifier: PropTypes.func,
};

export default OffsetSelect;
